import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISales, ISalesInitialState } from "./salesModel";
import {
  cancelEInvoice,
  cancelEWay,
  createSales,
  deleteSales,
  generateEInvoice,
  generateEwayBill,
  getAllSales,
  getSalesByID,
  getSalesPrint,
  updateSales,
} from "./services/sales.services";
import moment from "moment";

const initialState: ISalesInitialState = {
  loading: false,
  error: "",
  SalesStateForGST: null,
  SalesDeleteIndex: -1,
  AutoSubmit: false,
  GeneratedInvoiceNo: "",
  DutyAndTaxSalesDeleteIndex: -1,
  SalesID: null,
  SalesList: [],
  SalesDetail: {
    invoice_no_string: "",
    voucher_type_id: 1,
    sales_challan_id: null,
    invoice_no: "",
    invoice_date: moment().toDate(),
    vendor_id: null,
    terms_day: null,
    due_date: "",
    sales_ledger_id: null,
    taxable_amount: null,
    sub_total: null,
    round_off: null,
    total_amount: null,
    total_gst: null,
    gst: null,
    cgst: null,
    sgst: null,
    igst: null,
    vehicle_no: "",
    transport_name: "",
    remarks: "",
    // delivery_slip_no: "",
    scheme: null,
    cartoon: null,
    bag: null,
    frieght: null,
    terms_and_condition_id: null,
    sales_items: [],
    sales_duty_and_taxes: [],
  },
  SalesPrintDetail: {},
  EWayBillDetail: {},
  FilterSales: {
    account_name: "",
  },
};

const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    clearSalesDetails: (state) => {
      state.SalesDetail = initialState.SalesDetail;
    },
    setEWayBillDetail: (state, action) => {
      state.EWayBillDetail = action.payload;
    },
    clearEWayBillDetail: (state) => {
      state.EWayBillDetail = initialState.EWayBillDetail;
    },
    setSalesID: (state, action) => {
      state.SalesID = action.payload;
    },
    clearSalesID: (state) => {
      state.SalesID = initialState.SalesID;
    },
    setSalesDeleteIndex: (state, action) => {
      state.SalesDeleteIndex = action.payload;
    },
    setSalesStateForGST: (state, action) => {
      state.SalesStateForGST = action.payload;
    },
    clearSalesStateForGST: (state) => {
      state.SalesStateForGST = initialState.SalesStateForGST;
    },
    setFilterSales: (state, action) => {
      state.FilterSales = action.payload;
    },
    setDutyAndTaxSalesDeleteIndex: (state, action) => {
      state.DutyAndTaxSalesDeleteIndex = action.payload;
    },
    setAutoSubmit: (state, action) => {
      state.AutoSubmit = action.payload;
    },
    clearFilterSales: (state) => {
      state.FilterSales = initialState.FilterSales;
    },
    setGeneratedInvoiceNo: (state, action) => {
      state.GeneratedInvoiceNo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSales.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSales.fulfilled,
      (state, action: PayloadAction<ISales[]>) => {
        state.loading = false;
        state.SalesList = action.payload || [];
      }
    );
    builder.addCase(getAllSales.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SalesList = [];
    });

    builder.addCase(createSales.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createSales.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createSales.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateSales.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateSales.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateSales.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteSales.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSales.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSales.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getSalesByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSalesByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.SalesDetail = action.payload;
    });
    builder.addCase(getSalesByID.rejected, (state, action) => {
      state.loading = false;
      state.SalesDetail = initialState.SalesDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getSalesPrint.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSalesPrint.fulfilled, (state, action: any) => {
      state.loading = false;
      state.SalesPrintDetail = action.payload;
    });
    builder.addCase(getSalesPrint.rejected, (state, action) => {
      state.loading = false;
      state.SalesPrintDetail = initialState.SalesPrintDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(generateEInvoice.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(generateEInvoice.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(generateEInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(cancelEInvoice.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(cancelEInvoice.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(cancelEInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(generateEwayBill.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(generateEwayBill.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(generateEwayBill.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(cancelEWay.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(cancelEWay.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(cancelEWay.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setEWayBillDetail,
  clearEWayBillDetail,
  clearSalesDetails,
  clearSalesID,
  setSalesID,
  setSalesDeleteIndex,
  setSalesStateForGST,
  clearSalesStateForGST,
  setFilterSales,
  clearFilterSales,
  setDutyAndTaxSalesDeleteIndex,
  setGeneratedInvoiceNo,
  setAutoSubmit,
} = salesSlice.actions;
export default salesSlice.reducer;
